import {
  addResearcher as addResearcherToProtocol,
  addReviewerCommittee,
  deleteAmendment as deleteProtocolAmendment,
  fetchAssignedReviewers,
  fetchDateDictumCommittee,
  fetchDictums,
  fetchReviewersDictums,
  fetchDictumTypes,
  fetchReviewerDictums,
  fetchReviewerInvitation,
  fetchReviewersCommittee,
  inviteResearchersByEmail,
  removeAmendmentAttachment as removeAttachmentFromAmendment,
  replyReviewerInvite,
  saveAmendment as saveProtocolAmendment,
  saveAttachments as saveAmendmentAttachments,
  saveCommitteeDictum as saveAmendmentCommitteeDictum,
  saveDateDictumCommittee,
  saveReviewerDictum as saveRevDictum,
  sendAmendmentToEvaluation as sendAmendmentToEvaluationByCommittees,
  updateProtocolUser,
  saveFunders,
  saveFinancingInformation,
  removeFunder as removeFunderFromAmendment,
  fetchAmendmentFunders,
  fetchFinancingCommitments,
  addFinancingCommitment as addFinancingCommitmentAmendment,
  editFinancingCommitment as editFinancingCommitmentAmendment,
  removeCommitment as removeAmendmentCommitment,
  saveFunderAgreement,
  updateFunderInformation as updateFunder,
  fetchAmentmentResearchers,
  removeResearcher,
  updateDictumFile,
  updateEndDate,
  sendReplyToAmendment,
  cancelReviewerInvitation,
  resendReviewerInvitation as reinviteReviewer,
  resendInvitation,
  createReviewerDictumTask as createReviewerTask,
} from './api'

const saveAmendment = async({ commit }, payload) => {
  try {
    
    const response = await saveProtocolAmendment(payload)
    const amendment = response.data.data.amendment;
    
    commit('SET_AMENDMENT', amendment)

    commit('SET_AMENDMENT_FINANCING_INFORMATION', amendment.financing_information)
    
    return response
  } catch (e) {
    console.error(e)
  }
}

const saveAttachments = async({ commit }, payload) => {
  try {
    const response = await saveAmendmentAttachments(payload)
    
    commit('SET_AMENDMENT_ATTACHMENTS', response.data.data.attachments)
    
    return response
  } catch (e) {
    console.error(e)
  }
}

const removeAmendmentAttachment = async({ commit }, payload) => {
  try {
    const response = await removeAttachmentFromAmendment(payload)
    
    commit('SET_AMENDMENT_ATTACHMENTS', response.data.data.attachments)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const deleteAmendment = async({ commit }, payload) => {
  try {
    return await deleteProtocolAmendment(payload)
  } catch (e) {
    console.error(e)
  }
}

const sendAmendmentToEvaluation = async({ commit }, payload) => {
  try {
    return await sendAmendmentToEvaluationByCommittees(payload)
  } catch (e) {
    console.error(e)
  }
}

const setNewProtocolUser = async({ commit }, payload) => {
  try {
    const response = await updateProtocolUser(payload)
    
    commit('SET_CURRENT_RESEARCHER', response.data.data.researcher)
    
    return response
  } catch (e) {
    console.error(e)
  }
}

const addResearcher = async({ commit }, payload) => {
  try {
    const response = await addResearcherToProtocol(payload)
        
    return response
  } catch (e) {
    console.error(e)
  }
}

const sendInvitationByEmail = async({ commit }, payload) => {
  try {
    return await inviteResearchersByEmail(payload)
  } catch (e) {
    console.error(e)
  }
}

const getAssignedReviewers = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          amendment,
          committee,
        } = payload
  
  let assignedReviewers = []
  
  try {
    assignedReviewers = (await fetchAssignedReviewers({
      query,
      pageSize,
      page,
      amendment,
      committee,
    })).data.data
    
    if (page > 1) {
      assignedReviewers = state.assignedReviewers.concat(assignedReviewers)
    }
    
    commit('SET_ASSIGNED_REVIEWERS', assignedReviewers)
    
    return assignedReviewers
  } catch (e) {
    console.error(e)
  }
}

const getDictums = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          amendment,
          committee,
        } = payload
  
  let dictums = []
  
  try {
    const response = (await fetchDictums({
      query,
      pageSize,
      page,
      amendment,
      committee_id: committee ? committee.id : null,
    }))
    
    dictums = response.data.data
    
    if (page > 1) {
      dictums = state.dictums.concat(dictums)
    }
    
    commit('SET_DICTUMS', dictums)
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const getReviewersDictums = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          amendment,
          committee,
        } = payload
  
  let dictums = []
  
  try {
    const response = (await fetchReviewersDictums({
      query,
      pageSize,
      page,
      amendment,
      committee_id: committee ? committee.id : null,
    }))
    
    dictums = response.data.data
    
    if (page > 1) {
      dictums = state.dictums.concat(dictums)
    }
    
    commit('SET_DICTUMS', dictums)
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const saveDateDictum = async({ commit }, payload) => {
  try {
    return await saveDateDictumCommittee(payload)
  } catch (e) {
    console.error(e)
  }
}

const getDateDictum = async({ commit }, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          amendment,
          committee,
        } = payload
  
  let dates = []
  
  try {
    const response = (await fetchDateDictumCommittee({
      query,
      pageSize,
      page,
      amendment,
      committee_id: committee ? committee.id : null,
    }))
    
    dates = response.data.data
    
    if (page > 1) {
      dates = state.dates.concat(dates)
    }
    
    commit('SET_DATES', dates)
    
    return response.data
  } catch (e) {
    console.error(e)
  }
}

const getReviewers = async({
  commit,
  state,
}, payload) => {
  const page     = payload.page ? payload.page : 1
  const pageSize = payload.pageSize ? payload.pageSize : 20
  
  const {
          query,
          committee,
          amendment,
        } = payload
  
  let reviewers = []
  
  try {
    reviewers = (await fetchReviewersCommittee({
      query,
      pageSize,
      page,
      committee,
      amendment,
    })).data.data
    
    if (page > 1) {
      reviewers = state.reviewers.concat(reviewers)
    }
    
    commit('SET_REVIEWERS', reviewers)
    
    return reviewers
  } catch (e) {
    console.error(e)
  }
}

const getCommitteeDictums = async({ commit, state }, payload) => {
  const { amendment, committee } = payload
  
  let dictums = []
  
  try {
    const response = (await fetchDictums({
      amendment,
      committee: committee ? committee.id : null,
    }))
    
    dictums = response.data.data
    
    commit('SET_COMMITEE_DICTUMS', dictums)
    
    return dictums
  } catch(e) {
    console.error(e)
  }
}

const addReviewer = async({ commit }, payload) => {
  try {
    const response = await addReviewerCommittee(payload)
  
    commit('SET_REVIEWERS', response.data.data.researchers)
    
    return response
  } catch(e) {
    console.error(e)
  }
}

const getReviewerInvitation = async({ commit }, payload) => {
  try {
    const response = await fetchReviewerInvitation(payload)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const replyInvite = async({ commit }, payload) => {
  try {
    const response = await replyReviewerInvite(payload)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const getReviewerDictums = async({ commit }, payload) => {
  try {
    const response = await fetchReviewerDictums(payload)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const saveReviewerDictum = async({ commit }, payload) => {
  try {
    return await saveRevDictum(payload)
  } catch(e) {
    console.error(e)
    
    return e
  }
}

const getDictumTypes = async({
  commit,
  state,
}, payload) => {
  const {
          query,
          keyList,
          committee,
          amendment,
        } = payload
  
  let dictumTypes = []
  
  try {
    dictumTypes = (await fetchDictumTypes({
      query,
      keyList,
      amendment: amendment,
      committee: committee.id,
    })).data.data
    
    commit('SET_DICTUM_TYPES', dictumTypes)
    
    return dictumTypes
  } catch (e) {
    console.error(e)
  }
}

const saveCommitteeDictum = async({ commit }, payload) => {
  try {
    return await saveAmendmentCommitteeDictum(payload)
  }
  catch (e) {
    console.error(e)
  }
}

const saveAmendmentFinancing = async({ commit }, payload) => {
  try {
    const response = await saveFinancingInformation(payload)
    
    commit('SET_AMENDMENT_FINANCING_INFORMATION', response.data.data.financing_information)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const syncFunders = async({ commit }, payload) => {
  try {
    const response = await saveFunders(payload)
    
    commit('SET_AMENDMENT_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const removeFunder = async({ commit }, payload) => {
  try {
    const response = await removeFunderFromAmendment(payload)
    
    commit('UPDATE_AMENDMENT_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const getAmendmentFunders = async({ commit }, protocol) => {
  try {
    const response = await fetchAmendmentFunders(protocol)
    
    commit('UPDATE_AMENDMENT_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const getFinancingCommitments = async({ commit }, amendment) => {
  try {
    const response = await fetchFinancingCommitments(amendment)
    
    commit('UPDATE_FINANCING_COMMITMENTS', response.data.data.commitments)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const addFinancingCommitment = async({ commit, state }, payload) => {
  try {
    const response = await addFinancingCommitmentAmendment(payload)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const editFinancingCommitment = async({ commit, state }, payload) => {
  try {
    const response = await editFinancingCommitmentAmendment(payload)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const removeCommitment = async({ commit }, payload) => {
  try {
    return (await removeAmendmentCommitment(payload)).data.data
  } catch(e) {
    console.error(e)
  }
}


const attachAgreementToFunder = async({ commit }, payload) => {
  try {
    const response = await saveFunderAgreement(payload)
    
    commit('UPDATE_AMENDMENT_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch(e) {
    console.error(e)
  }
}

const updateFunderInformation = async({ commit }, payload) => {
  try {
    const response = await updateFunder(payload)
    
    commit('UPDATE_AMENDMENT_FUNDERS', response.data.data.funders)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const getAmendmentResearchers = async({ commit }, amendment) => {
  try {
    const response = await fetchAmentmentResearchers(amendment)
    
    commit('SET_AMENDMENT_RESEARCHERS', response.data.data.researchers)

    commit('SET_AMENDMENT_EXTERNAL_RESEARCHERS', response.data.data.external_researchers)
  }
  catch (e) {
    console.error(e)
  }
}

const removeResearcherFromAmendment = async({ commit }, amendment) => {
  try {
    return await removeResearcher(amendment)
  }
  catch (e) {
    console.error(e)
  }
}

const resendResearcherInvitation = async({ commit }, researcher) => {
  try {
    return await reinviteResearcher(researcher)
  }
  catch(e) {
    console.error(e)
  }
}

/**
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const saveDictumFile = async({ commit }, payload) => {
  try {
    const response = await updateDictumFile(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

/**
 * Update end date in amendment extension.
 *
 * @param commit
 * @param payload
 * @returns {Promise<*>}
 */
const updateAmendmentEndDate = async({ commit }, payload) => {
  try {
    const response = await updateEndDate(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

/**
 * Reply invitation to researchers amendment.
 *
 * @param commit
 * @param payload
 * @returns {Promise<*|undefined>}
 */
const sendInviteReply = async({ commit }, payload) => {
  try {
    return await sendReplyToAmendment(payload)
  } catch (e) {
    console.error(e)
  }
}

const cancelReviewer = async({
  commit,
  state,
}, payload) => {
  try {
    return await cancelReviewerInvitation(payload)
  } catch (e) {
    console.error(e)
  }
}

const resendReviewerInvitation = async({
  commit,
  state,
}, payload) => {
  try {
    return await reinviteReviewer(payload)
  } catch (e) {
    console.error(e)
  }
}

const resendInvitationReviewer = async({ commit }, payload) => {
  try {
    return await resendInvitation(payload)
  } catch (e) {
    console.error(e)
    
    return e
  }
}

const createReviewerDictumTask = async({ commit }, payload) => {
  try {
    return await createReviewerTask(payload)
  } catch (e) {
    console.error(e)
    
    return e
  }
}

export default {
  saveAmendment,
  saveAttachments,
  deleteAmendment,
  removeAmendmentAttachment,
  sendAmendmentToEvaluation,
  setNewProtocolUser,
  addResearcher,
  sendInvitationByEmail,
  getAssignedReviewers,
  getDictums,
  getReviewersDictums,
  saveDateDictum,
  getDateDictum,
  getReviewers,
  getCommitteeDictums,
  addReviewer,
  getReviewerInvitation,
  replyInvite,
  getReviewerDictums,
  saveReviewerDictum,
  getDictumTypes,
  saveCommitteeDictum,
  saveAmendmentFinancing,
  syncFunders,
  removeFunder,
  getAmendmentFunders,
  getFinancingCommitments,
  addFinancingCommitment,
  editFinancingCommitment,
  removeCommitment,
  attachAgreementToFunder,
  updateFunderInformation,
  getAmendmentResearchers,
  removeResearcherFromAmendment,
  saveDictumFile,
  updateAmendmentEndDate,
  sendInviteReply,
  cancelReviewer,
  resendReviewerInvitation,
  resendInvitationReviewer,
  createReviewerDictumTask,
}
